import React, { useState } from 'react';
import { supabase } from '../lib/supabaseClient';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const AddExpert = () => {
 const navigate = useNavigate();
 const { t } = useTranslation();
 const [formData, setFormData] = useState({
    name: '',
    specialty: '',
    contact_email: '',
    contact_phone: '',
    years_experience: '',
    certified: false,
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const { data: { session } } = await supabase.auth.getSession();
      if (!session) throw new Error(t("expert.alert.mustBeLoggedIn"));

      const { error } = await supabase.from('experts').insert([
        {
          client_id: session.user.id,
          ...formData,
          years_experience: parseInt(formData.years_experience)
        }
      ]);

      if (error) throw error;

      alert(t("expert.alert.success"));
      navigate('/estimation');
    } catch (error) {
      alert(t("expert.alert.error", { error: error.message }));
    }
  };

  return (
    <div className="p-6 max-w-xl mx-auto">
      <h1 className="text-xl font-bold mb-4">{t("expert.add.title")}</h1>
      <form onSubmit={handleSubmit} className="grid grid-cols-1 gap-4">
        <input
          type="text"
          name="name"
          placeholder={t("expert.form.name.placeholder")}
          value={formData.name}
          onChange={handleChange}
          required
          className="border p-2 rounded"
        />
        <input
          type="text"
          name="specialty"
          placeholder={t("expert.form.specialty.placeholder")}
          value={formData.specialty}
          onChange={handleChange}
          className="border p-2 rounded"
        />
        <input
          type="email"
          name="contact_email"
          placeholder={t("expert.form.email.placeholder")}
          value={formData.contact_email}
          onChange={handleChange}
          className="border p-2 rounded"
        />
        <input
          type="tel"
          name="contact_phone"
          placeholder={t("expert.form.phone.placeholder")}
          value={formData.contact_phone}
          onChange={handleChange}
          className="border p-2 rounded"
        />
        <input
          type="number"
          name="years_experience"
          placeholder={t("expert.form.years.placeholder")}
          value={formData.years_experience}
          onChange={handleChange}
          className="border p-2 rounded"
        />

        <label className="inline-flex items-center">
          <input type="checkbox" name="certified" checked={formData.certified} onChange={handleChange} className="mr-2" />
          {t("expert.form.certified.label")}
        </label>

        <button type="submit" className="bg-blue-600 hover:bg-blue-700 text-white py-2 rounded">
         {t("expert.button.submit")}
        </button>
      </form>
    </div>
  );
};

export default AddExpert;
